var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12228 0.0282236C2.99094 -0.0730174 3.87179 0.0999508 4.61403 0.517516L29.9209 13.4313L23.5163 19.2504L2.12228 0.0282236ZM0.1756 1.7757C0.0535562 2.15614 -0.00547643 2.55063 0.000399063 2.9465V39.0493C-0.00547643 39.4452 0.0535562 39.8397 0.1756 40.2201L21.5891 20.9979L0.1756 1.7757ZM23.5357 22.7454L2.12228 41.9676C2.99135 42.078 3.87568 41.9043 4.61403 41.4783L29.9209 28.5645L23.5357 22.7454ZM40.1215 18.6563L32.4515 14.7419L25.4435 20.9979L32.4321 27.2713L40.102 23.357C42.6327 22.0639 42.6327 19.9319 40.102 18.6388L40.1215 18.6563Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.2c23c420436f539652acd9686c19fb28.svg";
export { ForwardRef as ReactComponent };